import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const cohort_bulk_participantsScreenModule = defineScreen({
  app: "coaching",
  screen_id: "cohort-bulk-participants",
  path: "/cohorts/:cohort_id/participants/bulk",
  params: ["cohort_id"],
  heading: { text: "Bulk import participants", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "deny",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "page.load" }
  ],
  recipe: "Page-1",
  data: { seedNeeds: ["readonly-walk-session"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/cohort-bulk-participants.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default cohort_bulk_participantsScreenModule;
